import { CircleMinus } from "lucide-react";
import React, { useContext, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { ActionIcon } from "@mantine/core";
import { AuthContext } from "../../../providers/AuthProvider";
import { queryClient } from "../../../App";
import { HttpClientError } from "../../../providers/HttpClient";
import ToggleAssigneeTagApiService from "../services/api/ToggleAssigneeTagApiService";
import { useToasts } from "../../../providers/notifications/ToastsContext";

type UnAssignTagActionIconProps = {
  employeeId: number;
  tagId: number;
};

const UnAssignTagActionIcon: React.FC<UnAssignTagActionIconProps> = ({
  employeeId,
  tagId,
}) => {
  const auth = useContext(AuthContext);
  const { showToast } = useToasts();

  const { isLoading, isError, error, isSuccess, mutate } =
    ToggleAssigneeTagApiService();

  useEffect(() => {
    if (isError) {
      showToast({
        strapiId: "unassign_tag_failed",
        data: {
          message: HttpClientError(error),
        },
      });
    }
  }, [isError, error]);

  useEffect(() => {
    if (isSuccess) {
      queryClient
        .invalidateQueries(["TagsDetailsApiService", tagId])
        .then(() => {
          showToast({ strapiId: "unassign_tag_success" });
        });
    }
  }, [isSuccess]);

  if (!auth) {
    return <Navigate replace to="/login" />;
  }

  return (
    <ActionIcon
      loading={isLoading}
      onClick={() =>
        mutate({
          tagId,
          employeeId,
          isTagged: false,
        })
      }
    >
      <CircleMinus size={18} />
    </ActionIcon>
  );
};

export default UnAssignTagActionIcon;
